import { getControllersOf, getTopmostOverlay } from './background-inert';
import { focusInside } from './focusable';

export class FocusRestorer {
  constructor() {
    this.stack = [];
  }

  remember = (overlay = null) => {
    this.stack.push({ trigger: document.activeElement, overlay });
  };

  restore = () => {
    const { trigger, overlay } = this.stack.pop() ?? {};
    const openedOverlay = getTopmostOverlay();
    const isInsideOpened = !openedOverlay || openedOverlay.contains(trigger);

    if (trigger && trigger !== document.body && isInsideOpened) {
      trigger.focus();
    }

    if (openedOverlay) {
      if (!openedOverlay.contains(document.activeElement)) {
        focusInside(openedOverlay);
      }

      return;
    }

    if (document.activeElement === document.body) {
      getControllersOf(overlay)[0]?.focus();
    }
  };

  isTopmost = (overlay) => this.stack.at(-1)?.overlay === overlay;
}

export const sharedFocusRestorer = new FocusRestorer();
